import { Link } from "react-router-dom";

import { UserStore } from '../../stores/UserStore';
import Notifications from "./notifications/Notifications";

const TopBar = () => {

    const isAdmin = UserStore.useState( ( state ) => state.isAdmin );

    return (
        <div className="container-fluid">

            <div className="d-flex justify-content-between main-card-tob-navbar pb-1 pt-2 mt-2">
                <ul className="navbar-nav flex-row">
                    <li className="nav-item dropdown mr-4">
                        <a
                            data-cy="btnMasterDropdown"
                            className="nav-link dropdown-toggle"
                            // href="#"
                            role="button"
                            data-toggle="dropdown"
                            aria-expanded="false"
                        >
                            Master
                        </a>
                        <div className="dropdown-menu">
                            <Link data-cy="btnTemplateType" className="dropdown-item" to="/csv-tool/template-types">
                                Template Type
                            </Link>
                            <Link data-cy="btnNetoworks" className="dropdown-item" to="/csv-tool/networks">
                                Networks
                            </Link>
                        </div>
                    </li>
                    <li className="nav-item dropdown mr-4">
                        <a
                            data-cy="btnTemplateDropdown"
                            className="nav-link dropdown-toggle"
                            // href="#"
                            role="button"
                            data-toggle="dropdown"
                            aria-expanded="false"
                        >
                            Template
                        </a>
                        <div className="dropdown-menu">
                            <Link data-cy="linkCreateTemplate" className="dropdown-item" to="/">
                                Create Template
                            </Link>
                            <Link data-cy="linkTemplateList" className="dropdown-item" to="/csv-tool/templates">
                                Template List
                            </Link>
                            <Link data-cy="linkRequestedTemplateList" className="dropdown-item" to="/csv-tool/requested-templates">
                                Requested Template List
                            </Link>
                        </div>
                    </li>
                    <li className="nav-item dropdown mr-4">
                        <a
                            className="nav-link dropdown-toggle"
                            role="button"
                            data-toggle="dropdown"
                            aria-expanded="false"
                        >
                            Import
                        </a>
                        <div className="dropdown-menu">
                            <Link className="dropdown-item" to="/csv-tool/report">
                                Report
                            </Link>
                            <Link className="dropdown-item" to="/csv-tool/import-list">
                                Import List
                            </Link>
                        </div>
                    </li>
                </ul>
                <Notifications />
            </div>
            
        </div>
    );
};

export default TopBar;